<template>
    <v-dialog v-model="dialog">
        <template #activator="{on}">
            <v-btn v-on="on">Detail</v-btn>
        </template>
        <v-card>
            <v-card-title>Product Stock Logs</v-card-title>
                <v-card-text>
                    <v-data-table
                    :headers="headers"
                    :items="tableData"
                >
                    <template #[`item.created_at`]="{item}">
                        {{ item.created_at | formatDate}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn icon @click.stop="open(item.id)">
                            <v-icon small>mdi-dots-horizontal</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
export default {
    data: () =>({
        dialog:false,
        tableData:[],
        totalCount:0,
        headers:[
            { text: "Date", value: "created_at" },
            { text: "Log", value: "log" },
            { text: "Initial", value: "initial" },
            { text: "Variation", value: "variation" },
            { text: "Final", value: "final" },
            { text: "Location", value: "location.location" },
            { text: "User", value: "user.displayName" },
        ]
    }),
    props:{
        value:{
            type: Object,
            required: true
        }
    },
    watch:{
        dialog(val){
            if(val){
                this.init()
            }
        }
    },
    computed:{
        model:{
            get(){
                return this.value;
            },
            set(value){
                this.$emit('input',value);
            }
        }
    },
    methods:{
        ...mapActions("productStockLog",{getProductStockLogs: "get"}),
        init(){
            this.getProductStockLogs(this.model)
            .then((data) => {
                this.tableData = data.data;
                this.totalCount = data.total;
            })
        },
    },
    filters:{
        formatDate (value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY, HH:mm:ss');
        }
    }
}
</script>

<style>

</style>